import React, { useEffect } from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { ServiceEventNames, ServiceActionTypes, HorseGender } from '../../shared/utils/ServicesConstants';
import { LeaseFieldNames } from '../utils/HorseLeasingConstants';
import { TranslationKeys } from '../../../../constants/TranslationKeys';
import { useFormContext, useWatch } from "react-hook-form";
import EahsForm from "../../../../components/EahsForm";
import FormAsyncSelect from "../../../../components/FormInputs/FormAsyncSelect";
import FormTextInput from "../../../../components/FormInputs/FormTextInput";
import { eformInput } from "../../../../common/cssclasses";

const HorseLeasingLesseeSection = ({
    promiseOptions,
    isReadOnly
}) => {
    const { translate } = useTranslate();
    const { control, formState: { errors }, setValue } = useFormContext();
    const lesseeId = useWatch({ control, name: LeaseFieldNames.LESSEE_ID });

    useEffect(() => {
        setValue(LeaseFieldNames.LESSEE_MOBILE, lesseeId?.mobile || "");
        setValue(LeaseFieldNames.LESSEE_ID_NUMBER, lesseeId?.idNumber || "");
        setValue(LeaseFieldNames.LESSEE_EMAIL, lesseeId?.email || "");
    }, [lesseeId, setValue]);

    return (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.LESSEE, "Lessee")}>
            <div className="row">
                <FormAsyncSelect
                    name={LeaseFieldNames.LESSEE_ID}
                    label={translate(TranslationKeys.LESSEE, "Lessee")}
                    required
                    loadOptions={promiseOptions}
                    disabled={isReadOnly}
                    isClearable
                    containerClass={eformInput}
                />

                <div className={eformInput}>
                    <FormTextInput label={translate("web.mobileNo", "Mobile No")} name={LeaseFieldNames.LESSEE_MOBILE} disabled />
                </div>

                <div className={eformInput}>
                    <FormTextInput label={translate("web.passportEmiratesId", "Passport - EmiratesId")} name={LeaseFieldNames.LESSEE_ID_NUMBER} disabled />
                </div>

                <div className={eformInput}>
                    <FormTextInput label={translate("web.email", "Email")} name={LeaseFieldNames.LESSEE_EMAIL} disabled />
                </div>
            </div>
        </EahsForm>
    );
};

export default HorseLeasingLesseeSection;
